import { gql } from '@apollo/client';

export const UPDATE_ANTHROPOMETRIC = gql`
  mutation updateAnthropometric($antropometricData: AntropometricInput!) {
    updateAntropometric(antropometricData: $antropometricData) {
      id
      appointmentId
    }
  }
`;
